<template>
	<div class="my-table roleManagementPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t('roleManagement.txt1')}}</span>
				<span>{{$t('roleManagement.txt2')}} / {{$t('roleManagement.txt3')}}</span>
			</div>
		</div>

		<el-card class="tableCard p30 mt0">
			<div class=" flexCenterBtn">
				<Tag></Tag>
				<div class="flexEndBtn">
					<div class="searchBtn ml20" @click="dialogFormEditRoleVisible = true">{{$t('roleManagement.txt4')}}</div>
					<div class="searchBtn ml20 borderBtn" @click="handleDeleteUsers()">{{$t('roleManagement.txt5')}}</div>
					<div class="searchBtn ml20 borderBtn" @click="visibleSelectUser = true">{{$t('roleManagement.txt6')}}</div>
				</div>
			</div>
			<div>
				<el-row :gutter="40">
					<el-col :span="12">
						<el-table ref="multipleTable" :data="dataList" v-loading="loading" highlight-current-row @current-change="handleCurrentChange"
						:default-sort="{prop: 'projName', order: 'descending'}">
						<el-table-column :label="$t('roleManagement.txt7')" type="index" width="50"> </el-table-column>
						<el-table-column :label="$t('roleManagement.txt8')">
							<template slot-scope="scope">
								<span>{{scope.row.roleName?scope.row.roleName:'--'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('roleManagement.txt9')">
							<template slot-scope="scope">
								<span>{{scope.row.description?scope.row.description:'--'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('roleManagement.txt10')" width="100px">
							<template slot-scope="scope">
								<el-button @click="handleRoleDelete(scope.row)" class="handleBtn" type="text">{{$t('roleManagement.txt5')}}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="12">
					<el-table :data="userList" :default-sort="{prop: 'projName', order: 'descending'}" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="50">
						</el-table-column>
						<el-table-column :label="$t('roleManagement.txt11')">
							<template slot-scope="scope">
								<span>{{scope.row.userName}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('roleManagement.txt12')">
							<template slot-scope="scope">
								<span>{{scope.row.realName || '--'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('roleManagement.txt13')">
							<template slot-scope="scope">
								<span>{{scope.row.mobile||'--'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('roleManagement.txt14')">
							<template slot-scope="scope">
								<span>{{scope.row.email||'--'}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('menuManagement.txt9')">
							<template slot-scope="scope">
								<el-button @click="handleDeleteUsers(scope.row.id)" class="handleBtn" type="text">{{$t('roleManagement.txt5')}}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</div>
	</el-card>
	<!-- 添加角色弹窗 -->
	<u-dialog :title="$t('roleManagement.txt15')" width="420px" top="5vh" :visible.sync="dialogFormEditRoleVisible" @confirm="confirmRole('editRoleForm')">
		<div class="editForm">
		<el-form :model="editRoleForm" :rules="editRoleRules" ref="editRoleForm" label-width="100px"
		class="demo-ruleForm">
		<el-form-item :label="$t('roleManagement.txt16')" prop="roleName">
			<el-input v-model="editRoleForm.roleName" :placeholder="$t('roleManagement.txt19')"></el-input>
		</el-form-item>
		<el-form-item :label="$t('roleManagement.txt17')" prop="description">
			<el-input v-model="editRoleForm.description" :placeholder="$t('roleManagement.txt18')"></el-input>
		</el-form-item>
	</el-form>
</div>
</u-dialog>
<User :visible.sync="visibleSelectUser" @confirm="selectUserConfirm"></User>
</div>
</template>

<script>
	import {formatDate} from "@/plugins/date.js";
	import qs from 'qs';
	import User from '../../common/modal/User.vue';
	import Tag from './components/tag.vue';
	import menuMixin from './menuMixin';
	export default {
		mixins: [menuMixin],
		components: {
			User,Tag
		},
		data() {
			return {
				isEdit: false,
				visibleSelectUser: false,
				multipleSelection: [], //角色用户勾选
				dialogFormEditRoleVisible: false, //修改角色弹窗
				dialogFormAddVisible: false, //添加用户弹窗
				dialogFormEditPasswordVisible: false, //修改密码弹窗
				fromData: {}, //分享参数
				editRoleForm: {}, //修改角色参数
				addUserForm: {}, //添加用户参数
				editPasswordForm: {}, //修改密码参数
				//用于获取数据列表
				queryInfo: {
					cmptName: '',
					endCreateTm: '',
					pageNum: 1,
					pageSize: 10,
					productTmplCmptId: '',
					projName: '',
					spvTm: '',
					startCreateTm: '',
					submitterName: '',
					witnCde: '',
					witnType: '',
				},
				dataList: [{}],
				total: 0,
				// 修改角色规则
				editRoleRules: {
					roleName: [{
						required: true,
						message: this.$t('roleManagement.txt19'),
						trigger: 'blur'
					}, ],
				},
				userList: [],
				currentRow: {},
				loading: false,
			};
		},
		created() {
			this.loadData();
		},
		filters: {
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, "yyyy-MM-dd");
			},
		},
		methods: {
			// 数据加载(角色管理列表)
			async loadData(currentRowId = '') {
				this.loading = true
				const { data: res } = await this.$http.post("/role/list");
				this.loading = false;
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.dataList = res.result;
				this.userList = this.dataList[0].userInfos
				this.$nextTick(() => {
					if(currentRowId) {
						const currentRow = this.dataList.find(item => item.id == currentRowId);
						this.$refs.multipleTable.setCurrentRow(currentRow)
					}
					else {
						this.$refs.multipleTable.setCurrentRow(this.dataList[0]);
					}
				})
			},			
			handleCurrentChange(val) {
				this.currentRow = val;
				this.userList = val.userInfos
			},
			// 返回上一页
			returnPage() {
				this.$router.go(-1);
			},
			// 角色用户勾选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 修改角色
			handleEditRole() {
				this.dialogFormEditRoleVisible = true;
			},
			// 修改密码
			handleEditPassword() {
				this.dialogFormEditPasswordVisible = true;
			},
			// 角色删除
			handleRoleDelete(row) {
				let id = row.id;
				this.$confirm('<p class="color666 fz14">'+this.$t('roleManagement.txt20')+'</p>', this.$t('roleManagement.txt5'), {
					dangerouslyUseHTMLString: true,
					confirmButtonText: this.$t('roleManagement.txt27'),
					cancelButtonText: this.$t('roleManagement.txt28'),
					type: 'warning',
					center: true
				}).then(() => {
					this.$message({
						type: 'info',
						message: this.$t('userManagement.txt32')
					});
				}).catch(() => {
					this.deleteRole(id);
				});
			},
			// 删除角色
			async deleteRole(id) {
				let data = {
					id: id
				}
				const {
					data: res
				} = await this.$http.post("/role/delete?" + qs.stringify(data));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.loadData();
				this.$message({
					type: 'success',
					message: this.$t('roleManagement.txt29')
				});
			},
			// 角色添加用户 
			async selectUserConfirm(list) {
				const currentRowId = this.currentRow.id;
				const data = {
					roleId: currentRowId,
					userIds: list.map(item => item.id).join(',')
				}
				const { data: res } = await this.$http.post(`/role/addUser?` + qs.stringify(data));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.loadData(currentRowId);
				this.visibleSelectUser = false;
				this.$message({
					type: 'success',
					message: this.$t('roleManagement.txt23')
				});
			},
			// 用户删除
			async handleDeleteUsers(id) {
				const currentRowId= this.currentRow.id
				let selectList = id ? [id] : this.multipleSelection.map(item => item.id);
				console.log(selectList)
				if(!id && !this.multipleSelection.length) { 
					this.$message.warning(this.$t('roleManagement.txt24'))
					return
				}
				let list = [];
				this.userList.forEach(item =>{
					if(!selectList.includes(item.id)) {
						list.push(item.id)
					}
				});

				this.$confirm('<p class="color666 fz14">'+this.$t('roleManagement.txt25')+'</p><p class="color999 fz14">'+this.$t('roleManagement.txt26')+'</p>',
					this.$t('roleManagement.txt5'), {
						dangerouslyUseHTMLString: true,
						confirmButtonText: this.$t('roleManagement.txt27'),
						cancelButtonText: this.$t('roleManagement.txt28'),
						type: 'warning',
						center: true
					}).then(() => {
					}).catch(async () => {
						const data = {
							roleId: currentRowId,
							userIds: list.map(item => item).join(',')
						}
						const { data: res } = await this.$http.post(`/role/addUser?` + qs.stringify(data));
						if (!res.success) {
							return this.$message.error(res.message);
						}
						this.$message({
							type: 'success',
							message:this.$t('roleManagement.txt29')
						});
						this.loadData(currentRowId);
					});
				},
			// 添加编辑角色操作
			confirmRole(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.add();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 角色户管理添加/修改
			async add() {
				const { data: res } = await this.$http.post("/role/add?" + qs.stringify(this.editRoleForm));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.loadData();
				this.dialogFormEditRoleVisible = false;
			},
			// 搜索
			handleSearch() {
				this.queryInfo.pageNum = 1;
				this.queryInfo.pageSize = 10;
				this.loadData();
			},
			// 点击当前行
			selectRow(row, event, column) {
				console.log(row, event, column)
			}
		},
	};
</script>

<style lang="less" scoped>
	.el-icon-user{
		font-size: 20px;
		vertical-align: middle;
		margin-right: 5px;;
	}   
	.roleManagementPage {
		.back {
			display: inline-block;
			margin-right: 2.6rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}

		.w32 {

			/deep/ .el-input,
			/deep/ .el-input__inner {
				width: 100% !important;
			}
		}

		.mb15 {
			margin-bottom: 1.5rem;
		}

		.searchBox {
			/*width: 33.6rem !important;*/
			height: 3.2rem;

			.btnC {
				padding: 0.6rem 2.6rem;
			}
		}

		.tips {
			font-size: 1.4rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #98B9FF;
			margin-top: -10px;
		}

		/deep/ .el-dialog {
			/deep/ .el-input,
			/deep/ .el-input__inner {
				width: 100% !important;
			}

			// /deep/ .el-form-item:first-of-type,
			// /deep/ .el-form-item:last-of-type {
				// 	margin-bottom: 0;
				// }

				/deep/ .el-dialog .el-dialog__body .el-select .el-input__inner,
				.el-dialog .el-dialog__body .el-input__inner,
				.el-dialog .el-dialog__body .el-input {
					border-radius: 8px;
				}
			}
		}
		.handleBtn{
			padding: 0;
		}
	</style>
